export default function LoanTermsLabelConverter({
  repaymentFrequency,
  repaymentFrequencyMode,
} = {}) {

  let mode = repaymentFrequencyMode;
  if (repaymentFrequency  >= 2) {
    mode = `${repaymentFrequency} ${repaymentFrequencyMode}s`;
  }
  const termLabel = mode === 'single_payment' ? 'in a single repayment' : `every ${mode}`;
  return termLabel;
}



// WEBPACK FOOTER //
// ./src/utils/LoanTermsLabelConverter.js